import { Component, Input } from '@angular/core';

@Component({
    selector: 'pkp-activity-state-label',
    template: `
        <span>
            <span *ngIf="displayMode === 'text'" class="label label-medium">
                <span *ngIf="state === 'PROCESSED' && type === 'FCFS'">
                    SUCCESSFUL
                </span>
                <span *ngIf="state === 'PROCESSED' && type !== 'FCFS'">
                    PROCESSED
                </span>
                <span *ngIf="state === 'SUCCESFUL'"> SUCCESSFUL </span>
                <span *ngIf="state === 'UNSUCCESSFUL'"> UNSUCCESSFUL </span>
                <span *ngIf="state === 'WAITING'"> WAITING </span>
                <span *ngIf="state === 'APPROVED'"> APPROVED </span>
                <span *ngIf="state === 'LOST'"> LOST </span>
                <span *ngIf="state === 'PARTIALLY_WON'"> PARTIALLY WON </span>
                <span *ngIf="state === 'PREOPEN'"> PREOPEN </span>
                <span *ngIf="state === 'OPEN'"> OPEN </span>
                <span *ngIf="state === 'NEW'"> NEW </span>
                <span *ngIf="state === 'WITHDRAWN'"> WITHDRAWN </span>
                <span *ngIf="state === 'REJECTED'"> REJECTED </span>
                <span *ngIf="state === 'EXPIRED'"> EXPIRED </span>
                <span *ngIf="state === 'CLOSED'"> CLOSED </span>
                <span *ngIf="state === 'FULFILLED'"> FULFILLED </span>
                <span *ngIf="state === 'FINISHED'"> FINISHED </span>
                <span *ngIf="state === 'IN_PROGRESS'"> IN PROGRESS </span>
                <span *ngIf="state === 'COMPLETELY_WON'"> WON </span>
                <span *ngIf="state === 'ECONOMIC_TEST_PENDING'">
                    ECONOMIC TEST PENDING
                </span>
                <span *ngIf="state === 'PENDING'"> PENDING </span>
                <span *ngIf="state === 'APPROVED_EXIT'"> APPROVED EXIT </span>
                <span *ngIf="state === 'APPROVED_ENTRY'"> APPROVED ENTRY </span>
                <span *ngIf="state === 'CANCELLED'"> CANCELLED </span>
                <span *ngIf="state === 'DRAFT'"> DRAFT </span>
                <span *ngIf="state === 'PUBLISHED'"> PUBLISHED </span>
                <span *ngIf="state === 'TERMINATED'"> TERMINATED </span>
            </span>
            <span *ngIf="displayMode === 'icon'">
                <span *ngIf="state === 'PROCESSED' && type === 'FCFS'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'PROCESSED' && type !== 'FCFS'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'SUCCESFUL'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'UNSUCCESSFUL'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'WAITING'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'APPROVED'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'LOST'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'PARTIALLY_WON'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'PREOPEN'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'OPEN'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'NEW'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'WITHDRAWN'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'REJECTED'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'EXPIRED'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'CLOSED'">
                    <i
                        class="fa fa-lg fa-minus-circle text-warning"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'FULFILLED'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'FINISHED'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'IN_PROGRESS'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'COMPLETELY_WON'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'ECONOMIC_TEST_PENDING'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'PENDING'">
                    <i
                        class="fa fa-lg fa-circle-o text-info"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'APPROVED_EXIT'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'APPROVED_ENTRY'">
                    <i
                        class="fa fa-lg fa-check-circle text-success"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'CANCELLED'">
                    <i
                        class="fa fa-lg fa-times-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
                <span *ngIf="state === 'TERMINATED'">
                    <i
                        class="fa fa-lg fa-exclamation-circle text-danger"
                        aria-hidden="true"
                    ></i>
                </span>
            </span>
        </span>
    `
})
export class ActivityStateLabelComponent {
    @Input() public state: string;
    @Input() public type: string;
    @Input('display-mode') public displayMode = 'text';
}
